import { render } from "./PDCSetup.vue?vue&type=template&id=6353b6e5"
import script from "./PDCSetup.vue?vue&type=script&lang=js"
export * from "./PDCSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__